import { createContext, useContext } from "react";
import PropTypes from "prop-types";

export const DataContext = createContext({});

export function DataProvider({ children }) {
	const hostAndPostPreloadState = window.hostAndPostPreloadState;
	if (!hostAndPostPreloadState) {
		throw new Error("hostAndPostPreloadState must be provided");
	}

	return (
		<DataContext.Provider value={hostAndPostPreloadState}>
			{children}
		</DataContext.Provider>
	);
}

export function useDataContext() {
	const context = useContext(DataContext);
	if (!context) {
		throw new Error("useData must be used within the DataProvider");
	}

	return context;
}

DataProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
